export default "__VITE_ASSET__CEW6U1BB__"